import React from 'react';

function SolidSmallButton({ name, textColor,showLeadingIcon, showTrailingIcon, bgColor }) {
    const dynamicTextColor = textColor || 'text-white'
    const dynamicBgColor = bgColor || 'bg-tamarillo-600'
    return (
        <>
            <button className={`flex justify-center text-14 font-semibold items-center py-8 px-12 rounded-8 cursor-pointer ${dynamicTextColor} ${dynamicBgColor}`}>
                {showLeadingIcon && (
                    <div>
                        {showLeadingIcon}
                    </div>
                )}
                <div>
                    {name}
                </div>
                {showTrailingIcon && (
                    <div>
                        {showTrailingIcon}
                    </div>
                )}
            </button>
        </>
    )
}

export default SolidSmallButton;